module.exports = __webpack_public_path__ + "img/15_dana_d.e0b38cee.png";